import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ModalModern from "./ModalModern";
import ModernPopupBody from "./common/ModernPopupBody";
import CustomBrandedHeader from "./common/CustomBrandedHeader";
import AuthForm from "../../forms/AuthForm";
import { logoutRdx } from "../../../store/redux_auth/authSlice";

function SessionExpiredModal() {
  const dispatch = useDispatch();
  const isVisible = useSelector((state) => state.auth.showSessionExpiredModal);

  // Set to true for styling, but use the selector for production
  // const isVisible = true;

  if (!isVisible) return null;

  const handleForceLogout = () => {
    dispatch(logoutRdx());
    window.location.href = "/sign-in";
  };

  return (
    <ModalModern onClose={handleForceLogout}>
      {/* Separated Branded Header */}
      <CustomBrandedHeader onForceLogout={handleForceLogout} />

      <ModernPopupBody>
        <div
          className="session-body-wrapper"
          style={{
            paddingTop: "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <AuthForm isModalMode={true} />
        </div>
      </ModernPopupBody>
    </ModalModern>
  );
}

export default SessionExpiredModal;
